export default __webpack_public_path__ + "static/logoTSE-32caf659e8192d1b0cbd5ddd2c90af44.png";